import { Controller } from "@hotwired/stimulus"

// Import Leads → Upload → Add Vendor (#16949 item 6). The Add Vendor button
// opens the real New Lead Vendor modal (the react-lead-vendor-bridge island,
// mountLeadVendorModal.tsx); when it saves, the island announces the vendor
// on window. This adds it to the Vendor select (or picks the existing option),
// chooses it, enables the select, puts the normal hint back, and fires
// `change` so import-wizard records it in the draft like a hand pick.
export const LEAD_VENDOR_CREATED_EVENT = "lead-vendor:created"

export default class extends Controller {
  static targets = ["select", "hint"]
  static values = { hint: String }

  connect () {
    this.onCreated = (event) => this.choose(event.detail)
    window.addEventListener(LEAD_VENDOR_CREATED_EVENT, this.onCreated)
  }

  disconnect () {
    window.removeEventListener(LEAD_VENDOR_CREATED_EVENT, this.onCreated)
  }

  choose (vendor) {
    if (!vendor?.id || !this.hasSelectTarget) return
    const select = this.selectTarget
    const value = String(vendor.id)
    let option = Array.from(select.options).find((o) => o.value === value)
    if (!option) {
      option = new Option(vendor.name, value)
      select.add(option, this.optionAfter(select, option.text))
    }
    select.disabled = false
    select.value = value
    if (this.hasHintTarget && this.hintValue) this.hintTarget.textContent = this.hintValue
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // The server lists vendors by name; keep a new one in that order (after
  // the blank "Select vendor" option). Null appends.
  optionAfter (select, name) {
    return Array.from(select.options).find((o) =>
      o.value !== "" && o.text.localeCompare(name, undefined, { sensitivity: "base" }) > 0) || null
  }
}
